import React, { useRef } from 'react';
import ProductTile from './ProductTile';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ title, products = [], children, collectionLocation }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef, {
    threshold: 0.2,
    once: true,
  });



  const tilesColumnCount = products?.length;

  const fillerColumns = 4 - (tilesColumnCount % 4);

  const needsFiller = fillerColumns > 0;

  const gridFiller = needsFiller && (
    <div
      className={classNames('product-tile--filler', {
        'col-span-1': fillerColumns === 1,
        'col-span-2': fillerColumns === 2,
        'col-span-3': fillerColumns === 3,
      })}
    />
  );

  return (
    <section
      ref={intersectionRef}
      className={classNames('products-list', {
        revealed: isIntersected,
      })}
    >
      {title && (
        <section className="bb--dark-brown p2">
          <h2 className="serif--sm serif--md--md">{title}</h2>
        </section>
      )}
      <div className="products-list__grid">
        {children}
        {products &&
          products.map((prod, index) => (
            <ProductTile
              backToCollection={collectionLocation ? collectionLocation : null}
              key={prod.variantId * (index + 1)}
              {...prod}
            />
          ))}
        {gridFiller}
      </div>
    </section>
  );
};
